import React, { useRef } from 'react';
import './SpotlightCard.css';

const SpotlightCard = ({ children, className = '', spotlightColor = 'rgba(255, 255, 255, 0.25)', ...props }) => {
  const cardRef = useRef(null);

  const updateCoordinates = (x, y) => {
    if (!cardRef.current) {
      return;
    }
    cardRef.current.style.setProperty('--mouse-x', `${x}px`);
    cardRef.current.style.setProperty('--mouse-y', `${y}px`);
    cardRef.current.style.setProperty('--spotlight-color', spotlightColor);
  };

  const handlePointerMove = (event) => {
    const rect = cardRef.current?.getBoundingClientRect();
    if (!rect) {
      return;
    }

    const pointerX = event.clientX ?? event.touches?.[0]?.clientX;
    const pointerY = event.clientY ?? event.touches?.[0]?.clientY;

    if (typeof pointerX !== 'number' || typeof pointerY !== 'number') {
      return;
    }

    updateCoordinates(pointerX - rect.left, pointerY - rect.top);
  };

  const handlePointerLeave = () => {
    if (!cardRef.current) {
      return;
    }
    cardRef.current.style.removeProperty('--mouse-x');
    cardRef.current.style.removeProperty('--mouse-y');
  };

  return (
    <div
      ref={cardRef}
      className={`card-spotlight ${className}`.trim()}
      onMouseMove={handlePointerMove}
      onMouseLeave={handlePointerLeave}
      onTouchMove={handlePointerMove}
      {...props}
    >
      {children}
    </div>
  );
};

export default SpotlightCard;
